import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 text-14px font-semibold cursor-pointer mr-2" }, " Pengiriman Lainnya ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_more_loading = _resolveComponent("more-loading")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    class: "pt-5",
    isShadow: false,
    style: {"width":"200px","height":"180px"}
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_more_loading, { key: 0 }))
        : (_openBlock(), _createBlock("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productExpandIcons, (product, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                isShadow: false,
                class: "flex flex-col items-center justify-center"
              }, [
                _createVNode("img", {
                  class: "text-gray-lp-600 pt-2",
                  src: 
            require(`@/app/ui/assets/svg/product-logo/${product}-${
              _ctx.firstRender ? 'inactive' : 'active'
            }.svg`)
          ,
                  alt: "more-products-card",
                  width: "100",
                  height: "18"
                }, null, 8, ["src"])
              ]))
            }), 128)),
            _createVNode("div", {
              class: `top-12 w-full rounded-b-md ${_ctx.isJumboPack && _ctx.isPartnerPcu ? 'mt-4': 'mt-8'} py-1`
            }, [
              _createVNode("div", {
                class: "flex flex-row items-center justify-center",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.expandProduct && _ctx.expandProduct(...args)))
              }, [
                _hoisted_2,
                _createVNode(_component_Icons, {
                  name: "chevron-right",
                  class: "text-red-lp-100 cursor-pointer mr-2"
                })
              ])
            ], 2)
          ]))
    ]),
    _: 1
  }))
}